module.exports = __webpack_public_path__ + "img/Rectangle 3.48b37ea8.png";